/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForNextGenReportHandler extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForNextGenReportHandler");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForNextGenReportHandler.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForNextGenReportHandler>): BackgroundJobPayloadForNextGenReportHandler {
        let obj = Object.assign(new BackgroundJobPayloadForNextGenReportHandler(), model);
        BackgroundJobPayloadForNextGenReportHandler.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForNextGenReportHandler>): BackgroundJobPayloadForNextGenReportHandler {
        if (!model) return null;
        return BackgroundJobPayloadForNextGenReportHandler.newInstance(<BackgroundJobPayloadForNextGenReportHandler> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForNextGenReportHandler) {
        if (!obj) return;

        models.BackgroundJobPayloadForNextGenReportHandler.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForNextGenReportHandler): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForNextGenReportHandler.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the report run
     */
    report_run_id: string;

    /**
     * ID of the report being generated
     */
    report_id: string;

}
